import { getAdministrativeDivisionLabel, getAdministrativeDivisions } from '@quds/shared';
import { Select } from '@/components/ui/Select';

export interface AdministrativeDivisionSelectProps {
  id?: string;
  country: string;
  value: string;
  onChange: (code: string) => void;
  invalid?: boolean;
  disabled?: boolean;
  className?: string;
  'aria-describedby'?: string;
  /** When the country has no curated divisions, hide the control (returns null). */
  hideWhenEmpty?: boolean;
}

/** Admin area level-1 select driven by `getAdministrativeDivisions(country)`. */
export function AdministrativeDivisionSelect({
  id,
  country,
  value,
  onChange,
  invalid,
  disabled,
  className,
  'aria-describedby': describedBy,
  hideWhenEmpty = true,
}: AdministrativeDivisionSelectProps) {
  const divisions = getAdministrativeDivisions(country);
  if (hideWhenEmpty && divisions.length === 0) return null;

  const label = getAdministrativeDivisionLabel(country);
  const options = divisions.map((d) => ({ value: d.code, label: d.name }));

  return (
    <Select
      id={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      options={options}
      placeholder={`Select ${label.toLowerCase()}`}
      invalid={invalid}
      disabled={disabled || !country}
      className={className}
      aria-describedby={describedBy}
      aria-label={label}
    />
  );
}

export function administrativeDivisionFieldLabel(country: string): string {
  return getAdministrativeDivisionLabel(country || 'XX');
}
